import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid2 } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import React, { useState, useEffect } from 'react';
import { myApi } from '../../../../config/axiosConfig';
import Swal from 'sweetalert2';

// COMPONENTES
import MyAutoComplete from '../../../../components/inputs/MyAutoComplete';

const EditarOperador = ({ open, onClose, refresh, data }) => {

    // ===========================================
    // ESTADO PARA FORMULARIO
    // ===========================================

    const [formValues, setFormValues] = useState({});

    // ===========================================
    // USE EFFECT PARA LLAMAR DATOS
    // ===========================================
    
    useEffect(() => {

        setFormValues(data);

    }, [data]);

     // ===========================================
    // FUNCION PARA SUBMIT DEL FORMULARIO
    // ===========================================

    const submitForm = async ( values ) => {
    
        try {

            const response = await myApi.put('/operadores/update', values);

            if(response.data.success){

                onClose();

                Swal.fire({
                    icon: response.data.icon,
                    title: response.data.message,
                });

                refresh();

            }



        } catch (error) {

            console.log(error);

        }

    }

    // ===========================================

    return (

        <Dialog 
            open={open} 
            onClose={onClose} 
            fullWidth 
            maxWidth="xs"
        >

            <DialogTitle>Editar Operador {data?.nombre}</DialogTitle>

            <DialogContent sx={{ padding: 2 }}>

                <Formik
                    initialValues={formValues}
                    enableReinitialize={true}
                    validationSchema={Yup.object({
                            is_active: Yup.string().required('Status Obligatorio'),
                        })}
                    onSubmit={submitForm}
                >
                    {({ isSubmitting }) => (

                        <Form style={{ width: '100%' }}>

                            <Grid2 container spacing={2}>

                                {/* STATUS */}

                                <Grid2 size={12}>

                                    <MyAutoComplete
                                        name="is_active"
                                        label="Status"
                                        options={[
                                            { value: 'true', label: 'Activo' },
                                            { value: 'false', label: 'Inactivo' },
                                        ]}
                                    />

                                </Grid2>

                                <DialogActions sx={{ justifyContent: 'flex-end' }}>

                                    <Button 
                                        type="submit" 
                                        variant="contained" 
                                        color="primary"
                                        disabled={isSubmitting}
                                    >
                                        Guardar
                                    </Button>

                                    <Button onClick={onClose}>Cancelar</Button>

                                </DialogActions>

                            </Grid2>

                        </Form>

                    )}

                </Formik>

            </DialogContent>

        </Dialog>

    )

}

export default EditarOperador